import { useGetContext } from '../api/lending/lapiHooks';
import { useSuspenseGetContext } from '../api/lending/lapiHooks.suspense';

export function useStateKey() {
  const { context, getContext, loadingContext, contextError } = useGetContext();

  return {
    stateKey: context.stateKey || null,
    fetchSiteContext: getContext,
    loadingStateKey: loadingContext,
    contextError: contextError,
  };
}

export function useSuspenseStateKey(
  options: { throwIfNotLoggedIn?: boolean } = {},
) {
  const { context, getContext } = useSuspenseGetContext(options);

  return {
    stateKey: context.stateKey || null,
    fetchSiteContext: getContext,
  };
}
